import { ShiftType } from './shift-type.interface';
import { ShiftTypeService } from './shift-type.service';
const service = new ShiftTypeService();

export interface ShiftTypeState {
   shiftTypes: Array<ShiftType>;
}

const state = {
   shiftTypes: [],
};
const getters = {
   shiftTypes(state: any) {
      return state.shiftTypes;
   },
};
const mutations = {
   setShiftTypes(state: any, shiftTypes: Array<any>) {
      state.shiftTypes = shiftTypes;
   },
};
const actions = {
   async getShiftTypes(context: any) {
      return await service.getShiftTypes().then((shiftTypes) => {
         context.commit('setShiftTypes', shiftTypes);
         return shiftTypes;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
